var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-invite-member"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invite-member",
    clipPath: "url(#clip-invite-member)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_user-plus_3324922",
    transform: "translate(6.166 3.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31642",
    "data-name": "Path 31642",
    d: "M22.289,23.516V20.677A5.677,5.677,0,0,0,16.612,15H6.677A5.677,5.677,0,0,0,1,20.677v2.839",
    transform: "translate(0 5.031)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 5.677,
    cy: 5.677,
    r: 5.677,
    transform: "translate(5.967 3)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    y2: 8.427,
    transform: "translate(28.153 9.786)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x1: 8.427,
    transform: "translate(24.408 15.404)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteMember);
export default __webpack_public_path__ + "static/media/invite-member.79a657c8c958a242ce81918b8c3ea3c5.svg";
export { ForwardRef as ReactComponent };